
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Button from '../base/Button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="fixed top-0 w-full bg-white/95 backdrop-blur-sm shadow-md z-50">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <img 
              src="https://static.readdy.ai/image/73ef2aa8b67f0b1ba51e6666fcef6024/d6b3d5294f1861bfb4676f2aec75193f.jpeg"
              alt="Phoenix Achievers Team LLC"
              className="h-12 w-12 object-contain rounded-lg"
            />
            <div className="hidden md:block">
              <h1 className="text-xl font-bold text-black">Phoenix Achievers Team</h1>
              <p className="text-xs text-red-600 font-semibold">LLC</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link 
              to="/" 
              className={`font-semibold transition-colors hover:text-red-600 ${
                isActive('/') ? 'text-red-600' : 'text-black'
              }`}
            >
              Home
            </Link>
            <Link 
              to="/about" 
              className={`font-semibold transition-colors hover:text-red-600 ${
                isActive('/about') ? 'text-red-600' : 'text-black'
              }`}
            >
              About
            </Link>
            <Link 
              to="/services" 
              className={`font-semibold transition-colors hover:text-red-600 ${
                isActive('/services') ? 'text-red-600' : 'text-black'
              }`}
            >
              Services
            </Link>
            <Link 
              to="/portfolio" 
              className={`font-semibold transition-colors hover:text-red-600 ${
                isActive('/portfolio') ? 'text-red-600' : 'text-black'
              }`}
            >
              Portfolio
            </Link>
            <Link 
              to="/contact" 
              className={`font-semibold transition-colors hover:text-red-600 ${
                isActive('/contact') ? 'text-red-600' : 'text-black'
              }`}
            >
              Contact
            </Link>
          </nav>

          {/* Social Media & CTA */}
          <div className="hidden lg:flex items-center space-x-4">
            {/* Social Icons */}
            <div className="flex items-center space-x-2">
              <a 
                href="https://www.tiktok.com/@phoenixachieversteamllc" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center text-black hover:text-red-600 transition-colors"
              >
                <i className="ri-tiktok-line text-lg"></i>
              </a>
              <a 
                href="https://www.instagram.com/phoenixachieversteamllc/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center text-black hover:text-red-600 transition-colors"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a 
                href="https://www.facebook.com/profile.php?id=61584440590340&sk=directory_links" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center text-black hover:text-red-600 transition-colors"
              >
                <i className="ri-facebook-line text-lg"></i>
              </a>
              <a 
                href="https://x.com/Phoenixteamllc" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center text-black hover:text-red-600 transition-colors"
              >
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
            </div>
            <Button 
              onClick={() => window.REACT_APP_NAVIGATE('/contact')}
              className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 text-sm whitespace-nowrap"
            >
              Book Now
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden w-8 h-8 flex items-center justify-center text-black hover:text-red-600"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200">
            <div className="py-4 space-y-4">
              <Link 
                to="/" 
                className={`block px-4 py-2 font-semibold transition-colors ${
                  isActive('/') ? 'text-red-600' : 'text-black'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>
              <Link 
                to="/about" 
                className={`block px-4 py-2 font-semibold transition-colors ${
                  isActive('/about') ? 'text-red-600' : 'text-black'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                About
              </Link>
              <Link 
                to="/services" 
                className={`block px-4 py-2 font-semibold transition-colors ${
                  isActive('/services') ? 'text-red-600' : 'text-black'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Services
              </Link>
              <Link 
                to="/portfolio" 
                className={`block px-4 py-2 font-semibold transition-colors ${
                  isActive('/portfolio') ? 'text-red-600' : 'text-black'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Portfolio
              </Link>
              <Link 
                to="/contact" 
                className={`block px-4 py-2 font-semibold transition-colors ${
                  isActive('/contact') ? 'text-red-600' : 'text-black'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Contact
              </Link>
              <div className="px-4 py-2">
                <Button 
                  onClick={() => window.REACT_APP_NAVIGATE('/contact')}
                  className="w-full bg-red-600 hover:bg-red-700 text-white py-2 whitespace-nowrap"
                >
                  Book Now
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
